import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success : null,
  query: localStorage.getItem("query")
    ? JSON.parse(localStorage.getItem("query"))
    : null,
    
  queries: localStorage.getItem("queries")
    ? JSON.parse(localStorage.getItem("queries"))
    : [],

};


const querySlice = createSlice({
    name : "query",
    initialState : initialState,
    reducers : {
        setLoading(state, value){
            state.loading = value.payload
        },
        setQuery(state, value){
            state.query = value.payload
        },
        setQueries(state, value){
            state.queries = value.payload
        },
        setSuccess(state, value){
            state.success = value.payload;
        }
    }
})

export const {setLoading, setQueries, setQuery, setSuccess} = querySlice.actions;
export default querySlice.reducer;
